<template lang="pug">
  div
    el-tabs.content(:value="menu" @tab-click="mudarTab")
      template(v-for="tab in tabs")
        el-tab-pane(:name="tab.name")
          span(slot="label")
            | {{tab.label}} &nbsp

      div.container-tab
        router-view(
          :oficio="oficio"
          :oficios="oficios"
        )
</template>

<script>
import { mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'

const CADASTRO_COLETIVO_EMPTY = {
  dataFinalizacao: null,
  georreferenciamento: {
    geom: null,
    area: 0,
    perimetro: 0,
    municipios: [{ nome: null }]
  },
  pecaTecnica: {
    memorialDescritivo: null
  },
  usuario: {
    pessoa: {
      nomeRazaoSocial: ''
    }
  },
  perfil: { nome: '' }
}

const PROCESSO_EMPTY = {
  numeroProcesso: null,
  cadastroColetivo: cloneDeep(CADASTRO_COLETIVO_EMPTY),
  despachos: []
}

const OFICIO_CERTIDAO_NEGATIVA_EMPTY = {
  numeroOficio: null,
  dataEmissao: new Date(),
  cartorio: {
    endereco: {
      municipio: '',
      cep: null,
      bairro: null,
      rua: null,
      complemento: null
    },
    nome: '',
    registrador: null
  },
  processo: cloneDeep(PROCESSO_EMPTY)
}
export default {
  data () {
    return {
      oficio: cloneDeep(OFICIO_CERTIDAO_NEGATIVA_EMPTY),
      oficios: { matricula: {}, portaria: {} }
    }
  },

  async created () {
    try {
      const { idProcesso, idOficio } = this.$route.query
      if (idProcesso) {
        const response = await this.findByIdProcesso(idProcesso)
        this.oficio.processo = response
        this.oficios = {
          matricula: { ...response.matricula, processo: response },
          portaria: { ...response.portaria, processo: response }
        }
      } else if (idOficio) {
        const response = await this.findByIdOficio(idOficio)
        this.oficio = response
      } else {
        this.goToListagem()
      }
    } catch (error) {
      this.goToListagem()
    }
  },

  computed: {
    indexTabAtual () {
      return this.tabs.findIndex(tab => tab.name === this.$route.name)
    },

    tabs () {
      if (
        this.$route.name === 'cpat/matricula' ||
        this.$route.name === 'matricula/envioMatricula' ||
        this.$route.name === 'matricula/analise'
      ) {
        return [
          {
            label: 'Encaminhar Ofício de Matrícula ',
            name: 'matricula/envioMatricula',
            dadosRequest: {
              url: '',
              dados: this.oficios
            }
          },
          {
            label: 'Análise do processo ' + this.oficio.processo.numeroProcesso,
            name: 'matricula/analise'
          }
        ]
      }
      return [
        {
          label: 'Emissão de minuta de Portaria',
          name: 'minuta/emissao',
          dadosRequest: {
            url: '',
            dados: this.oficio
          }
        },
        {
          label: 'Análise do processo ' + this.oficio.processo.numeroProcesso,
          name: 'minuta/analise'
        }
      ]
    },

    menu () {
      return this.$route.name
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isUltimoPasso () {
      return this.indexTabAtual === this.tabs.length - 1
    }
  },

  methods: {
    ...mapActions({
      findByIdProcesso: 'processoArrecadacao/findById',
      findByIdOficio: 'oficioArrecadacao/findById',
      getMatriculaAndPortaria: 'oficioArrecadacao/getMatriculaAndPortaria'
    }),

    mudarTab (componente) {
      const indexTab = this.tabs.findIndex(
        tab => tab.name === componente._props.name
      )
      this.navigate(indexTab)
    },

    async navigate (indexTab) {
      try {
        this.$router.push({
          name: this.tabs[indexTab].name,
          query: {
            idOficio: this.oficio.id,
            idProcesso: this.oficio.processo.id
          }
        })
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-small: 12px;

.content {
  flex: 1;
  padding-top: 10px;
}

.container-tab {
  padding: 10px;
}

pre {
  font-size: $font-size-small;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/Minuta.vue